import React from 'react';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
interface Props {
	tab: HiringAssessmentGraphTabsEnum;
	setTab: (arg: HiringAssessmentGraphTabsEnum) => void;
	totalConections: number;
	onChange?: (value: HiringAssessmentGraphTabsEnum) => void;
	isTourActive: boolean;
}

export enum HiringAssessmentGraphTabsEnum {
	FUNNEL = 'funnel',
	MATCH = 'match',
	SALARY = 'salary',
}

const HiringAssessmentGraphTabs = ({ isTourActive, tab, setTab, totalConections, onChange }: Props) => {
	const location = useLocation();
	return (
		<>
			<div className="flex w-full md:max-w-[500px] dark:bg-[#1F2A37]">
				<button
					className={`walkthrough-first-element ${
						tab === HiringAssessmentGraphTabsEnum.FUNNEL
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_funnel',
							eventLabel: location.pathname,
						});
						setTab(HiringAssessmentGraphTabsEnum.FUNNEL);
						onChange && onChange(HiringAssessmentGraphTabsEnum.FUNNEL);
					}}
				>
					Funnel
				</button>
				<button
					className={`walkthrough-first-element ${
						tab === HiringAssessmentGraphTabsEnum.MATCH
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_match',
							eventLabel: location.pathname,
						});
						setTab(HiringAssessmentGraphTabsEnum.MATCH);
						onChange && onChange(HiringAssessmentGraphTabsEnum.MATCH);
					}}
				>
					Match
				</button>
				<button
					className={`walkthrough-second-element ${
						tab === HiringAssessmentGraphTabsEnum.SALARY
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_salary',
							eventLabel: location.pathname,
						});
						setTab(HiringAssessmentGraphTabsEnum.SALARY);
						onChange && onChange(HiringAssessmentGraphTabsEnum.SALARY);
					}}
				>
					Salary
				</button>
			</div>
		</>
	);
};

export default HiringAssessmentGraphTabs;
